import { axiosClient } from "./axiosClient";

export const expenseApi = {
  // LIST (paginated + filters)
  list: async (params = {}) => {
    const res = await axiosClient.get("/expenses/", { params });
    return res.data;
  },

  // CREATE (multipart/form-data if receipt included)
  create: async (formData) => {
    const res = await axiosClient.post("/expenses/", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  },

  // DETAIL
  detail: async (id) => {
    const res = await axiosClient.get(`/expenses/${id}/`);
    return res.data;
  },

  // UPDATE (PATCH)
  // if file included, call with isMultipart=true and pass FormData
  update: async (id, data, isMultipart = false) => {
    const config = isMultipart
      ? { headers: { "Content-Type": "multipart/form-data" } }
      : {};
    const res = await axiosClient.patch(`/expenses/${id}/`, data, config);
    return res.data;
  },

  // DELETE (soft delete backend)
  remove: async (id) => {
    const res = await axiosClient.delete(`/expenses/${id}/`);
    return res.data;
  },

  // CSV EXPORT (download)
  exportCsv: async (params = {}) => {
    const res = await axiosClient.get("/expenses/export/csv/", {
      params,
      responseType: "blob",
    });
    return res; // caller will handle blob download
  },

  // MONTHLY SUMMARY (charts)
  monthlySummary: async (params = {}) => {
    const res = await axiosClient.get("/expenses/summary/monthly/", { params });
    return res.data;
  },
  // TOTAL SUMMARY (cards)
  totalSummary: async (params = {}) => {
  const res = await axiosClient.get("/expenses/summary/total/", { params });
  return res.data; // { total: "3183.82", count: 3 }
},

};
